import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { NestApiProvider } from "../../nest-api";

@Injectable()
export class CoreAuthApi {

  private service: string = '';
  private model: string = 'core/auth/sso';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  listsLogin(codename: string): Observable<any> {
    const method: string = 'GET';
    const func: string = 'lists';
    const params: any = {};
    const urlParams: any = { codename };
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.request<any>(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/core-auth.api.ts